export enum InteractionType {
  Drawing = 'drawing',
  GraphicHotspot = 'graphicHotspot',
  InlineChoice = 'inlineChoice',
  MultipleChoiceMatrix = 'multipleChoiceMatrix',
  MultipleSelect = 'multipleSelect',
  OpenQuestion = 'openQuestion',
  PerformQuestion = 'perform',
  SingleChoiceMatrix = 'singleChoiceMatrix',
  SingleSelect = 'singleSelect',
  TextEntry = 'textEntry',
}
